import * as React from 'react';
import { SVGProps, memo } from 'react';

/**
 * НЕ РЕДАКТИРОВАТЬ
 *
 * Этот файл создан автоматически с помощью svgr
 *
 * Подробнее, как работать с иконками:
 * @see https://lvtv.me/icons
 */
const SvgMicOn = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 14 25" {...props}>
    <g fill="none" fillRule="evenodd" stroke="#FFF">
      <rect width={7.929} height={15.964} x={3.179} y={0.5} rx={3.964} />
      <path d="M7.09 18.843v5.437M.862 13.525c.766 3.55 2.85 5.324 6.252 5.324 3.403 0 5.498-1.774 6.284-5.324" />
    </g>
  </svg>
);
const Memo = memo(SvgMicOn);
export default Memo;
